import { DomainsEdit } from './DomainsEdit';
import { DomainsCreate } from './DomainsCreate';
import blankRAViews from '../../components/BlankRAViews';

export default {
  ...blankRAViews,
  edit: DomainsEdit,
  create: DomainsCreate,
};
